.root {
  height: fit-content;
  min-height: 22px;
  border-radius: var(--radiusMd);
  max-width: 100px;
  min-width: 50px;
}

.categoryIcon {
  flex-shrink: 0;
}
